"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useQIndex = () => {
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const query = _queryString.default.parse(location.search);
  const [currentQindex, setCurrentQindex] = (0, _react.useState)(query?.qindex);
  const handleQindexChange = newQindex => {
    setCurrentQindex(newQindex);
    if (newQindex !== query?.qindex) {
      let newQuery;
      if (newQindex !== '') {
        newQuery = {
          ...query,
          qindex: newQindex
        };
      } else {
        newQuery = {
          ...query,
          qindex: undefined
        };
      }
      history.push({
        pathname: location.pathname,
        search: `?${_queryString.default.stringify(newQuery)}`
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (currentQindex !== query?.qindex) {
      setCurrentQindex(query?.qindex);
    }
  }, [currentQindex, history, location, query]);
  return [currentQindex, handleQindexChange];
};
var _default = exports.default = useQIndex;